import React, { lazy } from 'react';

const MAX_RETRIES = 2;
export const CHUNK_RELOAD_KEY = 'chunk-reload';

/**
 * Ленивая загрузка компонента с возможностью повторной попытки загрузки
 * @param importFn - функция для импорта компонента
 */
export const lazyWithRetry: typeof React.lazy = importFn => {
  return lazy(async () => {
    for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
      try {
        const module = await importFn();
        sessionStorage.removeItem(CHUNK_RELOAD_KEY);
        return module;
      } catch {
        if (attempt < MAX_RETRIES) {
          await new Promise(r => setTimeout(r, 1000 * (attempt + 1)));
          continue;
        }

        if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
          sessionStorage.setItem(CHUNK_RELOAD_KEY, 'true');
          window.location.reload();
          return new Promise(() => {});
        }

        sessionStorage.removeItem(CHUNK_RELOAD_KEY);
        throw new Error('Chunk load failed after retries and reload');
      }
    }

    throw new Error('Chunk load failed after try and catch');
  });
};
